import PropTypes from 'prop-types'
import React, {useEffect, useState} from 'react'
import {JsonViewer} from '../../../../../../../common/JsonViewer.jsx'
import {HeaderTitle} from '../../../../../../../common/HeaderTitle.jsx'
import InputWiz from "../../../../../../../common/inputs/wizard/InputWiz.jsx";
import RadioWiz from "../../../../../../../common/inputs/wizard/RadioWiz.jsx";
import PartnerzyRepeater from "../parts/PartnerzyRepeater.jsx";
import RealizatorzyRepeater from "../parts/RealizatorzyRepeater.jsx";
import {optionsTakNie} from "../../../../../../../utils/options.js";
import {Button, Col, Row} from "react-bootstrap";
import {useRegon} from "../../../../../../../../api/domain/regon/queries/useRegon.jsx";
import {toast} from 'react-toastify'
import {LabelFor} from "../../../../../../../common/inputs/LabelFor.jsx";

export const SposobRealizacji = (props) => {
    const wiz = props.wiz
    const regonValue = wiz?.form?.partnerstwo_lider_regon || ''
    const normalizedRegonValue = regonValue?.toString().trim()
    const regonTest = useRegon(regonValue, 'test')
    const regonData = useRegon(regonValue, 'data')
    const [regonState, setRegonState] = useState({
        checked: '',
        exists: false,
        ownerEmail: '',
        loading: false,
        error: '',
        missingPhone: false,
        missingEmail: false,
    })

    const isPartnerstwo = wiz?.form?.czy_partnerstwo === 'Tak'
    const isWnioskodawcaLiderem = wiz?.form?.czy_wnioskodawca_liderem === 'Tak'
    const showRealizatorzy = wiz?.form?.czy_z_realizatorami === 'Tak'

    useEffect(() => {
        setRegonState((prev) => ({
            ...prev,
            checked: '',
            exists: false,
            ownerEmail: '',
            error: '',
            missingPhone: false,
            missingEmail: false,
        }))
    }, [regonValue])

    const resolveErrorMessage = (errors) => {
        if (!errors) return ''
        if (Array.isArray(errors?.regon)) return errors.regon[0]
        if (errors?.regon) return errors.regon
        if (Array.isArray(errors?.identyfikator)) return errors.identyfikator[0]
        if (errors?.identyfikator) return errors.identyfikator
        if (typeof errors === 'string') return errors
        return ''
    }

    const handleRegonTest = async () => {
        const regon = normalizedRegonValue
        if (!regon) return
        setRegonState((prev) => ({...prev, loading: true}))
        const res = await regonTest.refetch()
        const data = res?.data
        const errorMessage = resolveErrorMessage(data?.errors)

        if (data?.status === 'failed' && data?.list?.length) {
            setRegonState((prev) => ({
                ...prev,
                checked: regon,
                exists: false,
                ownerEmail: '',
                loading: false,
                error: '',
                missingPhone: false,
                missingEmail: false,
            }))
            return
        }

        if (errorMessage) {
            toast.error(errorMessage)
            setRegonState({
                checked: regon,
                exists: false,
                ownerEmail: '',
                loading: false,
                error: errorMessage,
                missingPhone: false,
                missingEmail: false,
            })
            return
        }

        toast.success('REGON zweryfikowany pozytywnie.')
        setRegonState({
            checked: regon,
            exists: false,
            ownerEmail: '',
            loading: false,
            error: '',
            missingPhone: false,
            missingEmail: false,
        })
    }

    const handleRegonFetch = async () => {
        const regon = normalizedRegonValue
        if (!regon) return
        setRegonState((prev) => ({...prev, loading: true}))
        const res = await regonData.refetch()
        const data = res?.data

        if (data?.status === 'success' && data?.list?.length) {
            const item = data.list[0]
            wiz.setWizForm({
                ...wiz.form,
                partnerstwo_lider_nazwa: item?.nazwa || '',
                partnerstwo_lider_telefon: item?.telefon || '',
                partnerstwo_lider_email: item?.email || '',
            })
            setRegonState((prev) => ({
                ...prev,
                checked: regon,
                exists: false,
                ownerEmail: '',
                error: '',
                missingPhone: !item?.telefon,
                missingEmail: !item?.email,
            }))
        }

        setRegonState((prev) => ({...prev, loading: false}))
    }

    const canFetch =
        normalizedRegonValue &&
        regonState.checked === normalizedRegonValue &&
        !regonState.exists &&
        !regonState.error

    return (
        <div>
            <JsonViewer src={wiz?.form || {}} show={true}/>

            <HeaderTitle noHr size={'fs-3'} title={'Sposób realizacji projektu'}/>
            <HeaderTitle
                noHr
                size={'fs-4'}
                title={'Wprowadź dane dotyczące sposobu realizacji projektu'}
            />

            <div className={'d-flex flex-column gap-3'}>
                <RadioWiz
                    wiz={wiz}
                    keyName={'czy_partnerstwo'}
                    options={optionsTakNie}
                />

                {isPartnerstwo && (
                    <>
                        <RadioWiz
                            wiz={wiz}
                            keyName={'czy_wnioskodawca_liderem'}
                            options={optionsTakNie}
                        />

                        {!isWnioskodawcaLiderem && (
                            <div className={'d-flex flex-column gap-3'}>
                            <Row>
                                <Col xs={12} md={3}>
                                    <InputWiz
                                        wiz={wiz}
                                        keyName={'partnerstwo_lider_regon'}
                                        label={wiz?.getLabel('partnerstwo_lider_regon')}
                                    />
                                </Col>
                                <Col xs={12} md={3} className={'d-flex align-items-end'}>
                                    <div className={'d-flex gap-1 mb-4'}>
                                        <Button
                                            size={'sm'}
                                            variant={'info'}
                                            disabled={regonState.loading || !normalizedRegonValue}
                                            onClick={handleRegonTest}
                                        >
                                            Sprawdź REGON
                                        </Button>
                                        <Button
                                            size={'sm'}
                                            variant={'secondary'}
                                            disabled={regonState.loading || !canFetch}
                                            onClick={handleRegonFetch}
                                        >
                                            Pobierz z REGON/
                                        </Button>
                                    </div>
                                </Col>
                                <Col xs={12} md={6}>
                                    <InputWiz
                                        wiz={wiz}
                                        keyName={'partnerstwo_lider_nazwa'}
                                        label={wiz?.getLabel('partnerstwo_lider_nazwa')}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <InputWiz
                                        wiz={wiz}
                                        keyName={'partnerstwo_lider_telefon'}
                                        label={wiz?.getLabel('partnerstwo_lider_telefon')}
                                    />
                                </Col>
                                <Col>
                                    <InputWiz
                                        wiz={wiz}
                                        keyName={'partnerstwo_lider_email'}
                                        label={wiz?.getLabel('partnerstwo_lider_email')}
                                    />
                                </Col>
                            </Row>

                        </div>
                        )}
                        <div className={'d-flex flex-column align-items-start'}>
                            <LabelFor
                                id={'partner_list'}
                                label={props.wiz.getLabel('partner_list')}
                                tooltipText={props.wiz.getToolTip('partner_list')}
                            />
                        </div>

                        <div className={'d-flex flex-column gap-3'}>
                            <PartnerzyRepeater wiz={props.wiz} parentListName={'partner_list'} />
                        </div>
                    </>
                )}

                <RadioWiz
                    wiz={wiz}
                    keyName={'czy_z_realizatorami'}
                    options={optionsTakNie}
                />

                {showRealizatorzy && (
                    <>
                        <div className={'d-flex flex-column align-items-start'}>
                            <LabelFor
                                id={'realizator_list'}
                                label={props.wiz.getLabel('realizator_list')}
                                tooltipText={props.wiz.getToolTip('realizator_list')}
                            />
                        </div>
                        <div className={'d-flex flex-column gap-3 '}>
                            <RealizatorzyRepeater wiz={props.wiz} parentListName={'realizator_list'} />
                        </div>
                    </>
                )}
            </div>
        </div>
    )
}

SposobRealizacji.propTypes = {
    wiz: PropTypes.any,
}
export default SposobRealizacji